export default "<div id='popup-ctnr' (mouseenter)='onMouseEnter()'>\n    <div [innerHTML]='text'></div>\n    <button (click)='close()'>Fermer</button>\n</div>"